<template>
  <div :class="['pa-2 mrow', {'backgroundHover': active}]" @click="$emit('onClick', item)">
    <template v-if="item.uri">
      <span v-html="highlightedName"></span>
    </template>
    <template v-else>
      <span class="red--text">Func:</span>&nbsp;<span v-html="highlightedName"></span>
    </template>
  </div>
</template>

<script>
export default {
  props: ['item', 'active', 'searchText'],
  computed: {
    highlightedName () {
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-bold">$&</span>')
      if (!this.searchText) {
        return replacedStr
      }
      return '<span class="font-weight-regular">' + replacedStr + '</span>'
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  cursor: pointer;
  &:hover {
    background: var(--v-backgroundCard-base);
  }
}
</style>
